import React, { Fragment, useEffect, useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import sponsorStyle from "./sponsor.style";
import TextFieldMaterilUI from "@material-ui/core/TextField";
import Cookies from "universal-cookie";
import T from "Translate";
import { Field } from "react-final-form";
import InputAdornment from "@material-ui/core/InputAdornment";
import Validation from "Common/Validation/Validation";
import { validateSponsor } from "Common/Validation/ValidSponsor";
import FormHelperText from "@material-ui/core/FormHelperText";
import SponsorName from "./SponsorName/SponsorName";

import TextField from "../components/TextField";
import store from "Store";

const { numericOnly, minLength, composeValidators, required } = Validation;

const Sponsor = props => {
    const cookies = new Cookies();
    const { classes, form } = props;
    const formState = form.getState();

    const [refId, setRefId] = useState(null);

    useEffect(() => {
        if (!formState.values.sponsor) {
            cookies.set("refEnrollerName", "", { path: "/" });
        }
    }, [formState.values.sponsor]);

    useEffect(() => {
            setRefId(cookies.get("refId"));
    }, []);

    const countryNoSponsorID = ["HK"];
    const countryNoRefID = countryNoSponsorID.includes(store.getState().locale.country);

    return (
        <Fragment>
            <div className={classes.labelContent} data-testid="label_sponsor_id">
                <T>sponsor_id</T>
            </div>
            {refId ? (
                <Fragment>
                    <TextFieldMaterilUI
                        id="Sponsor"
                        className={classes.textDis}
                        value={refId}
                        disabled
                        error={cookies.get("refEnrollerError") ? true : false}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="start" className={classes.inputAdornment}>
                                    <SponsorName form={form} />
                                </InputAdornment>
                            ),
                            disableUnderline: true
                        }}
                    />
                    {cookies.get("refEnrollerError") ? (
                        <FormHelperText className={classes.refEnrollerError}>
                                <T>invalid_sponsor_id</T>{" "}
                        </FormHelperText>
                    ) : (
                        ""
                    )}
                </Fragment>
            ) : (
                <Field
                    name="sponsor"
                    type="text"
                    placeholder="123456789 | John Smith"
                    component={TextField}
                    className={classes.textFld}
                    InputProps={{
                        endAdornment: formState.values.sponsor && !formState.errors.sponsor && (
                            <InputAdornment position="start" className={classes.inputAdornment}>
                                <SponsorName form={form} />
                            </InputAdornment>
                        ),
                        disableUnderline: true
                    }}
                    validate={composeValidators(...[countryNoRefID ? undefined : required, numericOnly, minLength(6, "invalid_sponsor_id"), validateSponsor].filter(Boolean))}
                    validateFields={[]}
                    fullWidth
                    dataTestId="sponsor_id"
                />
            )}
        </Fragment>
    );
};

export default withStyles(sponsorStyle)(Sponsor);



// WEBPACK FOOTER //
// ./src/components/StartContainer/Sponsor/Sponsor.js